<template>
  <div>
    <h2 class="artist-portrait" :class="{loaded: loaded}" >
      <img :src="artistPortraitUrl" :alt="profileAlt"  />
    </h2>
    <tag-panel v-if="!mobile"
      v-on:handleShowAll="handleShowAll" 
      v-on:changeRegion="changeRegion" v-on:change="handleGalleryChange"
      :selItem="selitem" :region="artist.region" :galleries="galleries"></tag-panel>
    <div v-if="mobile" class="padtop-pf">
      
      <portfolio-controls :artist="artist" :details="details" :small="mobile" v-if="mobile" />
    </div>
    <div class="pf-intro" v-html="details.overview"></div>
    <div v-if="artist.video && lagvideo" class="pf-main">
      <video-widget :url="artist.video" v-on:play="sendGa" />
    </div>
    <div class="pf-main" v-html="details.text"></div>
    <div class="pf-main">
      <h3>{{ $nippets.portfolio.clientList }}</h3>
      {{ details.client_list }}
    </div>
    <div class="button-group-padded" v-if="!mobile">
      <div class="bgp-title">{{ $nippets.portfolio.wantToDiscuss }}</div>
      <email-and-call :artist="artist" animation />
    </div>
    <tag-panel v-if="mobile"
      v-on:handleShowAll="handleShowAll" 
      v-on:changeRegion="changeRegion" v-on:handleGalleryChange="handleGalleryChange"
      :selItem="selitem" :region="artist.region" :galleries="galleries"></tag-panel>
  </div>
</template>

<script>
import VideoWidget from '@/components/widgets/VideoWidget.vue'
import PortfolioControls from '@/components/panels/PortfolioControls.vue'
import EmailAndCall from '@/components/panels/EmailAndCall.vue'
import TagPanel from './pfintro/TagPanel.vue'

const memstore = {
  details: {}
}
export default {
  components: {
    VideoWidget,
    EmailAndCall,
    TagPanel,
    PortfolioControls
  },
  props: {
    artist: Object,
    animation: Boolean,
    gallery: Object,
    mobile: Boolean
  },
  created () {
    this.loadData ()
  },
  data () {
    return {
      details: {},
      galleries: [],
      loaded: false,
      artistPortraitUrl: '',
      profileAlt: '',
      selitem: 'all',
      lagvideo: false
    }
  },
  methods: {
    sendGa() {
      this.$k.sendGaEvent('ArtistPortfolio','VideoPlayed', this.artist.formatted_name)
    },
    loadData: async function () {
      if(!this.artist) return
      if(!this.artist.artist_id) return
      this.lagvideo = false
      this.loaded = false
    
      this.artistPortraitUrl = this.$k.getArtistPortraitUrl(this.artist.portfolio_url)
      let res = memstore.details[this.artist.artist_id + '-' + this.animation]
      if(!res) {
        res = await this.$k.getArtistDetails(this.artist, this.animation)
        memstore.details[this.artist.artist_id + '-' + this.animation] = res
      }
      await this.$store.dispatch('fetchGalleries')
      this.galleries = this.$store.getters.artistGalleries(this.artist).filter(el => ((el.animation === this.animation)&&(!el.redir)))
      this.details = res
      this.$emit('load', this.details)
      
      if(this.details.subhead) {
        let subhead = this.details.subhead.replace(/"/g, '')
        this.profileAlt = subhead
      }
      else {
        this.profileAlt = `${this.artist.formatted_name}'s Profile Photo`
      }
      await this.$k.loadImage(this.artistPortraitUrl)
      this.loaded = true
      this.$k.waitfor(3000).then(() => {
        this.lagvideo = true
      })
    },
    getRoute() {
      let route = '/artists/' + this.artist.portfolio_url
      if((this.animation) || (!this.artist.illustrator)) {
        route = '/animators/' + this.artist.portfolio_url
      }
      return route
    },
    handleGalleryChange (gallery) {
      this.$emit('changeGallery', gallery)
      this.selitem = gallery.url
      
    },
    handleShowAll () {
      let route = this.getRoute()
      this.$ixr.push(route)
      this.$emit('showAll')
      this.selitem = 'all'
      
      
    },
    changeRegion: function (region) {
      this.$emit('changeRegion', region)
    }
  },
  watch: {
    artist () {
      this.loaded = false
      this.loadData()
    },
    gallery () {
      if(this.gallery) {
        this.selitem = this.gallery.url
      }
    },
    animation() {
      this.loaded = false
      this.loadData()
    }
  }
}
</script>
<style>
.pf-main h3{
  font-weight:400;
  text-transform:uppercase;
  margin:20px 0 4px 0;
  font-size:17px;
  color:#101820;
}


</style>

<style scoped>
.pf-intro{
  line-height:21px;
}
.tag-panel{
  margin:20px 0;
}
.pf-main {
  font-weight:300;
  line-height:21px;
  margin: 30px 0;
}
h2.artist-portrait{
  border-radius:50%;
  width:70%;
  height:70%;
  overflow: hidden;
  transition: all 0.2s ease;
  margin:0;
  font-size:16px;
}

.artist-portrait img{
  width:100%;
  height:100%;
  display:block;
  opacity:0;
  transition: none;
}

.artist-portrait.loaded img{
  opacity:1;
  transition: opacity 0.5s ease;
}

.button-group-padded{
  margin:20px 0;
}

.bgp-title{
  font-weight:500;
  margin-bottom:10px;
}

.pf-location{
  padding:10px 6px 12px 20px;
  display:inline-block;
  background-image:url('../../assets/img/location-icon.svg');
  background-size:14px;
  background-position: left center;
  font-size:14px;
}

@media screen and (max-width:640px)
{
  h2.artist-portrait{
    margin-left:auto;
    margin-right:auto;
  }

  .padtop-pf{
    margin-top:12px;
  }
}
</style>